import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Link2rptd extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    //console.log(this.props.match.params[0]);
    //this.props.getuser(this.props.match.params[0]);
    console.log('I  am in componentDidMount ');
    this.props.getRptLnkbyreferenceid(this.props.match.params.id);
    this.props.gotopage();
  }

  // componentWillUnmount() {
  //   console.log('I  am in componentWillUnMount ');
  //   this.props.getRptLnkbyreferenceid(this.props.match.params.id);
  // }

  render() {
    // return <div>{new Date()}</div>;
    return null;
  }
}

Link2rptd.propTypes = {
  getRptLnkbyreferenceid: PropTypes.func.isRequired,
  gotopage: PropTypes.func.isRequired,
  reference_id: PropTypes.string
};

export default Link2rptd;



// WEBPACK FOOTER //
// ./src/components/views/Link2rptd/index.js